import React, { } from 'react'
import style from "./sidebarPage.module.scss"
import Sidebar from '../Components/sidebar/sidebar'
import LogComponent from '../Components/Log/log'
import Skeleton from "../Components/skeleton/skeleton"


const Log = (props) => {
    return (
        <div className={style.wrapper}>
            <div className={style.content}>
                <h3>فعالیت‌های ربات</h3>

                <LogComponent />
            </div>
            <div className={style.sidebar}>
                <Sidebar user={props.user} />

            </div>
        </div>
    )
}
export default Log